import { render, staticRenderFns } from "./CorporateProfiles.html?vue&type=template&id=06a6b51d&external"
import script from "./CorporateProfiles.js?vue&type=script&lang=js&external"
export * from "./CorporateProfiles.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports